import { useLocation } from 'react-router'
import { FdicInsuranceBanner } from './fdic-insurance-banner'

const FDIC_BANNER_PATHS = new Set([
  '/accounts',
  '/business/accounts',
  '/apply',
  '/apply/submitted',
  '/apply/express',
  '/business/apply',
])

export function FdicBannerConditional() {
  const { pathname } = useLocation()

  if (!FDIC_BANNER_PATHS.has(pathname)) {
    return null
  }

  return <FdicInsuranceBanner />
}
